import { API_URL, itemPerPage } from '../constants/index.js';

import {
    DIAGNOSTIC_REPORT,
    DIAGNOSTIC_REPORT_ERROR,
    DIAGNOSTIC_REPORT_SUCCESS,
    DIAGNOSTIC_REPORT_FILTERS,
    DIAGNOSTIC_REPORT_FILTERS_ERROR,
    DIAGNOSTIC_REPORT_FILTERS_SUCCESS
} from '../constants/diagnosticReportConstant';

import  * as XLSX from 'xlsx';

//#region GET DIAGNOSTIC REPORT
export function getDiagnosticReportSort(data) {
    return {
        type: DIAGNOSTIC_REPORT,
        data
    }
};

export function getDiagnosticReportSortSuccess(data, page) {
    return {
        type: DIAGNOSTIC_REPORT_SUCCESS,
        data,
        page
    }
};

export function getDiagnosticReportSortError(data) {
    return {
        type: DIAGNOSTIC_REPORT_ERROR,
        data
    }
};

const getHeaders = (sort, direction, filters, idCommunity)=>{

    const headers = {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
        'CommunityId': idCommunity,
        'custom_sort':sort,
        'sort_dir': direction===true? 1 : -1

    }

    if(filters?.ResidentFilter){
        headers.residentId=filters.ResidentFilter
    }

    if(filters?.PublicIpFilter){
        headers.publicIp=filters.PublicIpFilter
    }
    
    if(filters?.unitNumberFilter){
        headers.unitNumber=filters.unitNumberFilter
    }

    if(filters?.LocalIpFilter){
        headers.localIp=filters.LocalIpFilter
    }

    if(filters?.numberChannelFilter){
        headers.numberOfChannels=filters.numberChannelFilter
    }

    if(filters?.measuringLowestFilter){
        headers.measuringLowestVal=filters.measuringLowestFilter
    }

    if(filters?.measuringHighestFilter){
        headers.measuringHighestVal=filters.measuringHighestFilter
    }

    if(filters?.uploadSpeedFilter){
        headers.uploadSpeedTest=filters.uploadSpeedFilter
    }

    if(filters?.downloadSpeedFilter){
        headers.downloadSpeedTest=filters.downloadSpeedFilter
    }

    if(filters?.ssidOnOffFilter){
        headers.ssidOnOff=filters.ssidOnOffFilter
    }

    if(filters?.docsisFilter){
        headers.docsis=filters.docsisFilter
    }

    if(filters?.macAddressFilter){
        headers.macAddress=filters.macAddressFilter
    }

    if(filters?.serialFilter){
        headers.serial=filters.serialFilter
    }

    if(filters?.appVersionFilter){
        headers.appVersion=filters.appVersionFilter
    }

    if(filters?.signalStrengthFilter){
        headers.signalStrength=filters.signalStrengthFilter
    }

    if(filters?.deviceIdFilter){
        headers.deviceId=filters.deviceIdFilter
    }

    if(filters?.startDateFilter){
        headers.startDate=filters.startDateFilter
    }

    if(filters?.endDateFilter){
        headers.endDate=filters.endDateFilter
    }

    return headers;

}

export function GetDiagnosticReportSort(idCommunity,currentPage, sort, direction, filters) {
    return async(dispatch) => {
        dispatch(getDiagnosticReportSort());

        try{
            const response = await fetch(`${API_URL}/diagnosticReports/sort/${idCommunity}?limit=${itemPerPage}&page=${currentPage}`,
            {
                method: 'GET',
                headers: getHeaders(sort, direction, filters, idCommunity)
            });

            if(response.status===200){
                const data = await response.json();
                dispatch(getDiagnosticReportSortSuccess(data, currentPage));
    
                return data.data;
            }

        }catch(error){
            dispatch(getDiagnosticReportSortError(error));
        }
    }
};

export async function ExportDiagnostic(idCommunity, communityName, sort, direction, filters){
    try{
        const newCommunityName = communityName? communityName.split(' ').filter(a => a.length > 0).map(a => a.trim()).join('_'): '';

        const headers = getHeaders(sort, direction, filters, idCommunity)

        const fetchRes =  await  fetch(API_URL + `diagnosticReports/export/${idCommunity}`,
        {
            method: 'GET',
            headers: headers
        })

        let dataObj = undefined;
        let data=[];
        let headerArray = [];

        if(fetchRes && fetchRes.status === 200){
            dataObj = await fetchRes.json();
        }

        if(dataObj){
            data = await dataObj.data;
            headerArray = await dataObj.headers;
        }

        if(data && data.length > 0 && headerArray && headerArray.length > 0){
            const workSheet = XLSX.utils.json_to_sheet(data, {header:headerArray});
            const workBook = XLSX.utils.book_new();
            
            XLSX.utils.book_append_sheet(workBook, workSheet, "events");
            
            const fileName = `Diagnostic_Report_${newCommunityName}.csv`
    
            XLSX.writeFile(workBook, fileName);
        }

    }catch(err){
        return undefined
    }
}

//#endregion GET DIAGNOSTIC REPORT



//#region GET FILTERS

export function getDiagnosticReportFilter(data) {
    return {
        type: DIAGNOSTIC_REPORT_FILTERS,
        data
    }
};

export function getDiagnosticReportFilterSuccess(data, page) {
    return {
        type: DIAGNOSTIC_REPORT_FILTERS_SUCCESS,
        data
    }
};

export function getDiagnosticReportFilterError(data) {
    return {
        type: DIAGNOSTIC_REPORT_FILTERS_ERROR,
        data
    }
};

export function GetDiagnosticReportFilter(idCommunity) {
    return dispatch => {
        dispatch(getDiagnosticReportFilter());

        fetch(`${API_URL}/diagnosticReports/filters/${idCommunity}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                }
            })
            .then(res => res.json())
            .then(res => {
                dispatch(getDiagnosticReportFilterSuccess(res));

                return res;
            })
            .catch(error => {
                dispatch(getDiagnosticReportFilterError(error));

            })


    }
};


//#endregion GET FILTERS